window.wrapFirstWord = function wrapFirstWord(element) {
    var the_element = $(element);

    the_element.each(function () {
        var $this = $(this);

        $this.html($this.html().replace(/^(\w+)/, '<span class="js_firstWord firstWord">$1</span>'));
    });
}

$(document).ready(function () {
    'use strict';

    if ($('.js_wrapFirstWord').length) {
        wrapFirstWord('.franchiseMenuWrapper .js_wrapFirstWord a span');
    }
});